// Img
import { Button, Container, Text } from "@jds/core";
import emptyStateImg from "../../assets/svg/no-data/empty-box.svg";

// Mui
import { Box, Stack } from "@mui/material";
import PrimaryButton from "../UI/Buttons/PrimaryButton";

export default function EmptyState(props) {
  const { actionClick = () => { } } = props;
  const img = props?.img || (
    <img src={emptyStateImg} alt="empty box" style={{ width: "120px" }} />
  );
  const title = props?.title || "";
  // const subtitle = props?.subtitle || "Add something to view";
  const subtitle = props?.subtitle;
  return (
    <Container
      fullWidth
      horizontalAlign="center"
      verticalAlign="center"
      {...props}
    >
      <Box
        className="empty-state__container"
        textAlign="center"
        maxWidth="380px"
        {...props}
      >
        {img}
        <Stack
          direction="column"
          mt={5}
          spacing={2}
          sx={{ span: { textAlign: "center" } }}
        >
          <Text appearance="body-m-bold" text={title} as="span" />
          <Text
            appearance="body-m"
            text={subtitle}
            as="span"
            color="primary_grey_80"
          />
        </Stack>
        {props?.action !== false && (
          <Box mt={4}>
            <Button
              label="Get Started Now"
              onClick={() => {
                actionClick();
              }}
            />
          </Box>
        )}
      </Box>
    </Container>
  );
}
